import React, { useState } from 'react';
import HospitalHeader from '../shared/HospitalHeader';
import THICaseSetupGuide from './THICaseSetupGuide';

const SEGMENT_KEY = 'case-setup-segment';
const ROWS = [
  [{ id: 'cardiac', label: 'Cardiac' }, { id: 'vascular-aortic', label: 'Vascular/Aortic' }, { id: 'transplant', label: 'Transplant' }],
  [{ id: 'mcs', label: 'MCS' }, { id: 'cath-lab', label: 'Cath Lab' }, { id: 'specialty', label: 'Specialty' }],
];

/**
 * Case Setup Guide and Drug Finder share this screen. The guide reopens on the
 * case type used last; the finder has no case-type row.
 */
const CaseSetupScreen = ({ hospital, drugFinder = false, onBack, onOpenEnhancedRecovery }) => {
  const [segment, setSegmentState] = useState(() => {
    try { return localStorage.getItem(SEGMENT_KEY) || 'cardiac'; } catch { return 'cardiac'; }
  });
  const setSegment = (id) => {
    setSegmentState(id);
    try { localStorage.setItem(SEGMENT_KEY, id); } catch { /* ignore */ }
  };

  return (
    <div className="max-w-md mx-auto bg-gray-50 dark:bg-gray-900 min-h-screen">
      <HospitalHeader hospital={hospital} subtitle={drugFinder ? 'Drug Finder' : 'Case Setup Guide'} onBack={onBack} />

      {!drugFinder && (
        <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
          <div className="max-w-md mx-auto px-4 py-3">
            <div className="bg-gray-100 dark:bg-gray-900 rounded-xl p-1 space-y-1" role="tablist">
              {ROWS.map((row, i) => (
                <div key={i} className="grid grid-cols-3 gap-1">
                  {row.map((s) => {
                    const active = segment === s.id;
                    return (
                      <button
                        key={s.id}
                        role="tab"
                        aria-selected={active}
                        onClick={() => { setSegment(s.id); }}
                        className={`px-2 py-2 rounded-lg text-sm font-semibold transition-all truncate ${
                          active
                            ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm'
                            : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
                        }`}
                      >
                        {s.label}
                      </button>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="p-6">
        <THICaseSetupGuide
          onClose={onBack}
          hospital={hospital}
          activeSegment={drugFinder ? 'drug-finder' : segment}
          onSegmentChange={setSegment}
          onOpenEnhancedRecovery={() => { onOpenEnhancedRecovery?.(); }}
        />
      </div>
      <div className="h-8" />
    </div>
  );
};

export default CaseSetupScreen;
